import { Box, Button, Typography } from "@mui/material";
import { useUserControl } from "../../../context/SuperAdmin/UserControlContext";

const AllUsersPagination = () => {
  const { page, totalUsers, changePage } = useUserControl();

  const USERS_PER_PAGE = 20;
  const totalPages = Math.ceil(totalUsers / USERS_PER_PAGE);

  const canGoBack = page > 1;
  const canGoForward = page < totalPages;

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
      <Button
        onClick={() => canGoBack && changePage(page - 1)}
        disabled={!canGoBack}
        sx={{
          bgcolor: "#336B87",
          color: "white",
          borderRadius: 1,
          fontSize: "0.8rem",
          minWidth: "32px",
          height: "32px",
          textTransform: "none",
          p: 0,
          "&:hover": {
            bgcolor: "#2a5670",
          },
          "&.Mui-disabled": {
            color: "rgba(255, 255, 255, 0.6)",
            bgcolor: "rgba(51, 107, 135, 0.6)",
          },
        }}
      >
        {"<"}
      </Button>

      <Typography
        sx={{
          color: "#336B87",
          bgcolor: "white",
          fontSize: "0.8rem",
          borderRadius: 0,
          px: 1,
        }}
      >
        {page}
      </Typography>

      <Button
        onClick={() => canGoForward && changePage(page + 1)}
        disabled={!canGoForward}
        sx={{
          bgcolor: "#336B87",
          color: "white",
          borderRadius: 1,
          fontSize: "0.8rem",
          minWidth: "32px",
          height: "32px",
          textTransform: "none",
          p: 0,
          "&:hover": {
            bgcolor: "#2a5670",
          },
          "&.Mui-disabled": {
            color: "rgba(255, 255, 255, 0.6)",
            bgcolor: "rgba(51, 107, 135, 0.6)",
          },
        }}
      >
        {">"}
      </Button>
    </Box>
  );
};

export default AllUsersPagination;
